'use strict';

/**
 * CSS identifiers with whitespace are invalid
 * Hence this key will not cause a collision
 */

module.exports = ' css ';



/*****************
 ** WEBPACK FOOTER
 ** ./~/csjs/lib/css-key.js
 ** module id = 22
 ** module chunks = 0
 **/